export default "__VITE_ASSET__BJI6N3ZY__"